import React from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { formatTimestamp, formatResponseTime } from "@/utils/helpers";
import { TypingIndicator } from "./Spinner";

export const Message = ({
  message,
  showMetadata = false,
  messageRef = null,
}) => {
  const { t } = useTranslation();
  const isUser = message.role === "user";
  const isTyping = !isUser && message.isStreaming && !message.content;

  return (
    <div
      ref={messageRef}
      className={`gpc-message ${
        isUser ? "gpc-message-user" : "gpc-message-assistant"
      }`}
      role="article"
      aria-label={isUser ? "Mensaje del usuario" : "Mensaje del asistente"}
    >
      {/* Contenido del mensaje */}
      <div className="gpc-message-content">
        {isTyping ? (
          <TypingIndicator />
        ) : isUser ? (
          message.content.trim()
        ) : (
          <ReactMarkdown>{message.content}</ReactMarkdown>
        )}
      </div>

      {/* Timestamp */}
      <div
        className={`gpc-message-timestamp ${
          isUser ? "gpc-message-timestamp-user" : ""
        }`}
      >
        {formatTimestamp(message.timestamp)}
      </div>

      {/* Metadata (solo para mensajes del asistente) */}
      {!isUser && showMetadata && message.metadata && (
        <div className="gpc-message-metadata">
          {message.metadata.tokensUsed && (
            <div className="gpc-metadata-item">
              <strong>{t("metadata.tokensUsed")}:</strong>{" "}
              {message.metadata.tokensUsed}
            </div>
          )}
          {message.metadata.responseTimeMs && (
            <div className="gpc-metadata-item">
              <strong>{t("metadata.responseTime")}:</strong>{" "}
              {formatResponseTime(message.metadata.responseTimeMs)}
            </div>
          )}
          {message.metadata.model && (
            <div className="gpc-metadata-item">
              <strong>{t("metadata.model")}:</strong> {message.metadata.model}
            </div>
          )}
        </div>
      )}
    </div>
  );
};